import * as React from 'react';
import { useEffect, useState } from 'react';
import { Box, IconButton, useMediaQuery, useTheme } from '@mui/material';
import { CustomTheme } from '../../../../../types/customTheme/customTheme';

type Config = {
  nome: string;
  logo: string;
};

export function HeaderSiteLogo() {
  const theme = useTheme() as CustomTheme;
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const logo = theme.custom?.logo || '/images/logo_padrao.png';
  const nome = theme.custom?.nome || 'Nome Padrão';
  const linkPortalTransparencia = theme.custom?.linkPortalTransparencia || 'https://portaldatransparencia.gov.br';
  const logoPortalTransparencia = theme.custom?.logoPortalTransparencia || '/images/logo_portal_transparencia.png';

  /*
  const [config, setConfig] = useState<Config | null>(null);

  useEffect(() => {
    const hostname = window.location.hostname;
    const subdominio = hostname.split(".")[0];
    const empresa = subdominio || "empresa1";

    fetch(`/configs/${empresa}.json`)
      .then((res) => res.json())
      .then((data) => setConfig(data))
      .catch(() =>
        setConfig({
          nome: "Empresa Padrão",
          logo: "/images/logo_padrao.png",
        })
      );
  }, []);
 
  if (!config) return null;
 */

  return (
    <Box
      sx={{
        width: '100%',
        //height: { xs: 90, sm: 250 },
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        justifyContent: 'space-between',
        alignItems: 'center',
        overflow: 'hidden'
        //px: theme.spacing(2),
        //py: theme.spacing(1),
        //backgroundColor: theme.palette.background.default,
        // backgroundColor: "#ff2",
      }}
    >
      {/* LOGO DA EMPRESA */}

      {!isMobile && (
        <>
          <Box
            sx={{
              flex: 1,
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              overflow: 'hidden'
            }}
          >
            <IconButton
              onClick={() => (window.location.href = '/')}
              title="Início"
              sx={{
                width: '100%',
                height: '100%',
                p: 0
              }}
            >
              <img
                src={logo}
                alt={nome}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain'
                }}
              />
            </IconButton>
          </Box>
        </>
      )}

      {/* LOGO DO PORTAL */}
      <Box
        sx={{
          flex: 1,
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: { xs: 'center', sm: 'flex-end' },
          overflow: 'hidden'
        }}
      >
        <IconButton
          component="a"
          href={linkPortalTransparencia}
          target="_blank"
          rel="noopener"
          title="Portal da Transparência"
          sx={{
            width: '100%',
            height: '100%',
            p: 0
          }}
        >
          <img
            src={logoPortalTransparencia}
            alt="Portal da Transparência"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain'
            }}
          />
        </IconButton>
      </Box>
    </Box>
  );
}
